<template>
  <div class="search-container">
    <el-form :model="searchForm" :inline="true" class="search-form">
      <el-form-item :label="$t('CountryManagement.countryName')">
        <el-input
          v-model="searchForm.name"
          :placeholder="$t('CountryManagement.pleaseEnterCountryName')"
          clearable
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item :label="$t('CountryManagement.countryCode')">
        <el-input
          v-model="searchForm.code"
          :placeholder="$t('CountryManagement.pleaseEnterCountryCode')"
          clearable
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item :label="$t('CountryManagement.afterSaleSupport')">
        <el-select
          v-model="searchForm.is_after_sale"
          :placeholder="$t('CountryManagement.pleaseSelect')"
          clearable
          style="width: 120px"
        >
          <el-option :label="$t('CountryManagement.yes')" :value="1" />
          <el-option :label="$t('CountryManagement.no')" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">
          <el-icon><Search /></el-icon>
          {{ $t('CountryManagement.search') }}
        </el-button>
        <el-button @click="handleReset">
          <el-icon><Refresh /></el-icon>
          {{ $t('CountryManagement.reset') }}
        </el-button>
        <el-button type="success" @click="handleAdd" v-if="hasPermission('country.add')">
          <el-icon><Plus /></el-icon>
          {{ $t('CountryManagement.addCountry') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Search, Refresh, Plus } from '@element-plus/icons-vue';

export default {
  name: 'CountrySearchBar',
  components: {
    Search,
    Refresh,
    Plus
  },
  data() {
    const testPermissions = () => {
      const userId = localStorage.getItem('userId');
      const cacheKey = `subPermissions_${userId}`;
      const cache = localStorage.getItem(cacheKey);
      return cache ? JSON.parse(cache) : [];
    };
    
    return {
      searchForm: {
        name: '',
        code: '',
        is_after_sale: ''
      },
      subPermissions: testPermissions()
    };
  },
  methods: {
    // 检查权限
    hasPermission(permission) {
      if (!this.subPermissions || !Array.isArray(this.subPermissions)) {
        this.loadSubPermissions();
        return false;
      }
      
      return this.subPermissions.includes(permission);
    },
    
    async loadSubPermissions() {
      const userId = localStorage.getItem('userId');
      const cacheKey = `subPermissions_${userId}`;
      const cache = localStorage.getItem(cacheKey);
      
      if (cache) {
        this.subPermissions = JSON.parse(cache);
      } else {
        this.subPermissions = [];
      }
    },
    
    handleSearch() {
      // 过滤掉空值并添加后端需要的后缀
      const searchParams = {};
      Object.keys(this.searchForm).forEach(key => {
        if (this.searchForm[key] !== '' && this.searchForm[key] !== null && this.searchForm[key] !== undefined) {
          if (key === 'name' || key === 'code') {
            searchParams[`${key}-like`] = this.searchForm[key];
          } else if (key === 'is_after_sale') {
            searchParams[`${key}-eq`] = this.searchForm[key];
          } else {
            searchParams[key] = this.searchForm[key];
          }
        }
      });
      this.$emit('search', searchParams);
    },
    
    handleReset() {
      this.searchForm = {
        name: '',
        code: '',
        is_after_sale: ''
      };
      this.$emit('search', {});
    },
    
    handleAdd() {
      this.$emit('add');
    }
  }
};
</script>

<style scoped>
.search-container {
  background-color: #f5f5f5;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  height: 120px;
  min-height: 120px;
  max-height: 120px;
  overflow: hidden;
}

.search-form {
  margin: 0;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}

.search-form .el-form-item:last-child {
  margin-right: 0;
}

.el-button {
  margin-left: 10px;
}

.el-button:first-child {
  margin-left: 0;
}
</style> 